(function () {
    function getEnvName() {
        var host = (typeof window !== 'undefined' ? window.location.hostname : '').toLowerCase();

        if (host.includes('localhost')) return 'development';
        if (host.startsWith('test.')) return 'test';
        if (host.includes('staging')) return 'stage';
        if (host === 'universal-robots.com' || host === 'www.universal-robots.com') return 'production';

        return 'production';
    }

    if (typeof window !== 'undefined') {
        window.ur = window.ur || {};

        if (!window.ur.envName) {
            Object.defineProperty(window.ur, 'envName', {
                value: getEnvName(),
                writable: false,
                configurable: false,
                enumerable: true,
            });
        }
    }
})();
